import { css } from '@emotion/css';

const styles = {
  container: css`
    .MuiPaper-root {
      max-width: 812px;
      margin: 0 auto;
      border-top-left-radius: 10px;
      border-top-right-radius: 10px;
      box-shadow: 0px -2px 4px rgba(0, 0, 0, 0.25);
    }
  `,
  cancelButtonContainer: css`
    padding: 24px 0px 24px 8px;
  `,
  magicLinkContent: css`
    min-height: calc(80vh + 24px + 9px);
  `,
};

export default styles;
